import { useAxios } from 'src/hooks/use-axios';

type Options = {
  orderId: number;
};

export function useWithdrawBid() {
  return useAxios(
    (axios, baseConfig, { orderId }: Options) =>
      axios.request<null>({
        ...baseConfig,
        url: `${PRISMA_CONFIG.monolithApiUrl}/auctions/${orderId}`,
        method: 'DELETE',
      }),
    { neededOnPageLoad: false }
  );
}

export type WithdrawBidRequest = ReturnType<typeof useWithdrawBid>;
